import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DocumentPreview from '../../../components/DocumentPreview';
import InputBuscadorPaginadoWithFormik from '../../../components/InputBuscadorPaginadoWithFormik';
import InputWithFormik from '../../../components/inputs/InputWithFormik';
import KeyboardDatePickerWithFormik from '../../../components/inputs/KeyboardDatePickerWithFormik';
import Preview from '../../../components/Preview';
import FinalButtons from '../../../FinalButtons';
import FinalButtonsMobile from '../../../FinalButtonsMobile';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import axios from '../../../utils/axios';
import ESTADOS_FORMULARIO from '../../../utils/constants';
import { mainDefault } from '../../../utils/data-utils';
import Filter from '../../../utils/filter';
import {
  fetchPdfAsBase64,
  loadEventos,
  loadFormulario,
  schemaWithDateTransform,
  Yup
} from '../../../utils/form-utils';
import createParams from '../../../utils/tables-params';
import FormDataView from './FormDataView';
import FormikSubmitEffect from './FormikSubmitEffect';
import formulariosConfig from './FormularioConfig';

const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  previewContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    // marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(0),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5)
    }
  },
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const validationSchema = Yup.object().shape({
  formularios: Yup.array(Yup.object().shape({})).required(
    'Debe seleccionar formularios'
  ),
  fechaSalida: schemaWithDateTransform.test(
    'fechaAnterior',
    'No puede ser menor a la fecha de hoy',
    values => {
      if (values && moment(values).isBefore(moment(), 'day')) {
        return false;
      }
      return true;
    }
  ),
  idLoteRemesa: Yup.string().required()
});

const EnvioDNAForm = props => {
  const { enqueueSnackbar } = props;
  const formik = useRef();
  const classes = useStyles();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loadingSendPre, setLoadingSendPre] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const myRef = useRef(null);
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const [pdfPreview, setPdfPreview] = useState();
  const [pdfDespachoPreview, setPdfDespachoPreview] = useState();
  const [formPreview, setFormPreview] = useState();
  const [baseObject, setBaseObject] = useState({
    ...mainDefault
  });
  const [eventos, setEventos] = useState([]);
  const activeStep = 0;

  const onPdfView = async value => {
    try {
      setPdfPreview({
        url: '',
        title: 'Formulario EF'
      });
      const url = await fetchPdfAsBase64(
        `${process.env.REACT_APP_ROOT_API}reporte/generaPdf?formularioId=${
          value.id
        }`
      );
      console.log('value', value);
      setPdfPreview({
        url,
        title: 'Formulario EF',
        download: `formulario-${value.exportador.ruc}-${value.id}`
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onPdfDespachoView = async value => {
    try {
      setPdfDespachoPreview({
        url: '',
        title: 'Despacho'
      });
      const url = await fetchPdfAsBase64(
        `${
          process.env.REACT_APP_ROOT_API
        }reporte/generaPdfDespacho?formularioId=${value.id}`
      );
      setPdfDespachoPreview({
        url,
        title: 'Despacho',
        download: `despacho-${value.exportador.ruc}-${value.id}`
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onEdit = async item => {
    const formulario = await loadFormulario(item.id);
    setBaseObject(prev => ({ ...prev, ...formulario }));

    const eventosList = await loadEventos(item.id);
    setEventos(eventosList);
    setFormPreview({
      open: true,
      title: 'Vista previa'
    });
  };

  const configuraciones = formulariosConfig({
    classes: {},
    onPdfView,
    onPdfDespachoView,
    onEdit
  });
  const dataset = 'formulariosParaDNA';
  const gridProps = {
    spacing: 3,
    className: classes.inputGroup
  };

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const settings = datosSettings;
    const params = createParams({ ...props.datos.list, settings });
    if (params.filter) {
      params.filter.and(
        Filter.path('estadoActual.estado.nombre').eq(
          ESTADOS_FORMULARIO.ADMITIDO
        )
      );
      params.filter = JSON.stringify(params.filter);
    } else {
      params.filter = JSON.stringify(
        Filter.path('estadoActual.estado.nombre').eq(
          ESTADOS_FORMULARIO.ADMITIDO
        )
      );
    }
    axios
      .get(datosConfig.servicio, {
        data: {},
        params
      })
      .then(resp => {
        return props.datos.list.dataLoaded(
          resp.data.data.map(item => ({
            ...item,
            info: `${item.nombre} ${item.apellido}`
          })),
          {
            currentPage: resp.data.meta.currentPage - 1,
            pageSize: resp.data.meta.pageSize,
            itemsCount: resp.data.meta.total
          }
        );
      })
      .catch(() => {
        enqueueSnackbar('Error al obtener los datos', 'error');
      });
  };
  const onSubmitError = ({ values, errors }) => {
    console.log('error', values, errors);
    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const onSubmit = () => {
    setOpenConfirm(true);
    formik.current.setSubmitting(false);
  };

  const enviar = async () => {
    const { values } = formik.current;
    console.log('onSubmit', values);
    setLoadingSendPre(true);
    try {
      // setTouched({}, false);
      const valuesToSend = Object.assign({}, values);
      valuesToSend.fechaSalida = values.fechaSalida.format('DD/MM/YYYY');
      valuesToSend.idFormularios = values.formularios.map(item => item.id);
      try {
        await axios.post('formularios/enviar-tees', valuesToSend);
        enqueueSnackbar('Enviado correctamente', { variant: 'success' });
        history.push('/formularios');
      } catch (err) {
        if (err.response?.status === 400) {
          let message = '';
          if (err.response.data) {
            const erroresTees = err.response.data;
            message = Object.values(erroresTees).join('\n');
            enqueueSnackbar(message, {
              variant: 'error',
              style: { whiteSpace: 'pre-line' }
            });
          } else {
            enqueueSnackbar(err.response?.data || 'Error al intentar enviar', {
              variant: 'error'
            });
          }
        } else {
          enqueueSnackbar(err.response?.data || 'Error al intentar enviar', {
            variant: 'error'
          });
        }
      }

      setLoadingSendPre(false);
    } catch (error) {
      console.log(error);
      setLoadingSendPre(false);
    }
  };

  const handleClose = () => {
    setOpenConfirm(false);
  };

  const handleOk = () => {
    setOpenConfirm(false);
    enviar();
  };

  const onSelected = (_, item) => {
    const actual = [...(formik.current.values.formularios || [])];
    const existe = actual.find(val => val.id === item.id);
    if (!existe) {
      formik.current.setFieldValue(`formularios`, [...actual, item]);
    }
  };

  const onDelete = item => {
    const listaActual = formik.current.values.formularios;
    const listaNueva = listaActual.filter(val => val.id !== item.id);
    formik.current.setFieldValue(`formularios`, listaNueva);
  };

  const onDeleteAll = () => {
    formik.current.setFieldValue(`formularios`, '');
  };

  const handleBack = () => {
    history.push('/formularios');
  };

  const buttonProps = {
    okText: 'Enviar',
    cancelText: 'Volver',
    handleBack,
    isPhone,
    classes,
    loadingSendPre
  };

  const Buttons = () =>
    isPhone ? (
      <FinalButtonsMobile {...buttonProps} />
    ) : (
      <FinalButtons {...buttonProps} />
    );

  return (
    <div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={8}>
          <div ref={myRef} style={{ height: 16 }} />
          <Container maxWidth="md">
            <div style={{ paddingBottom: 40 }}>
              <Grid container item>
                <Typography variant="h6" gutterBottom>
                  Registro de Formularios en DNIT
                </Typography>
              </Grid>
              <Grid container item>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  Los datos serán enviados al sistema de la DNIT
                </Typography>
              </Grid>
              <Dialog
                open={openConfirm}
                onClose={handleClose}
                aria-labelledby="dialog-title"
              >
                <DialogTitle id="dialog-title">Enviar a DNIT</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {t('general.confirmDescription')}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>{t('general.cancel')}</Button>
                  <Button
                    onClick={handleOk}
                    color="primary"
                    variant="contained"
                  >
                    {t('general.send')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Formik
                // enableReinitialize
                initialValues={{
                  formularios: '',
                  fechaSalida: moment(),
                  idLoteRemesa: ''
                }}
                validationSchema={validationSchema}
                innerRef={formik}
                onSubmit={onSubmit}
              >
                {() => (
                  <>
                    <FormikSubmitEffect
                      onSubmitError={onSubmitError}
                      validationSchema={validationSchema}
                    />
                    <Form noValidate>
                      <Grid container {...gridProps}>
                        <Grid item xs={12} md={12}>
                          <ListDataProvider
                            listStore={props.datos.list}
                            render={listProps => (
                              <InputBuscadorPaginadoWithFormik
                                maxWidth="xl"
                                required
                                label="Formularios a enviar a DNIT"
                                name="formularios"
                                labelText={item =>
                                  `Guía: ${item.nroGuia || ''}`
                                }
                                sublabelText={item =>
                                  `Empresa: ${item.exportador.razonSocial ||
                                    ''}`
                                }
                                valueKey="id"
                                placeholder="Seleccione..."
                                list={listProps}
                                datosConfig={datosConfig}
                                datosSettings={datosSettings}
                                onReloadTable={onReloadTable}
                                multiple
                                onClick={onEdit}
                                onSelected={onSelected}
                                onDelete={onDelete}
                                onDeleteAll={onDeleteAll}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <KeyboardDatePickerWithFormik
                            label="Fecha de salida"
                            name="fechaSalida"
                            required
                            disablePast
                          />
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <InputWithFormik
                            label="Id de la Transacción, Lote, o Acta de la Remesa"
                            name="idLoteRemesa"
                            required
                          />
                        </Grid>
                      </Grid>
                      <Buttons />
                      {pdfPreview && (
                        <DocumentPreview
                          title={pdfPreview.title}
                          file={pdfPreview.url}
                          download={pdfPreview.download}
                          onClose={() => {
                            setPdfPreview();
                          }}
                        />
                      )}
                      {pdfDespachoPreview && (
                        <DocumentPreview
                          title={pdfDespachoPreview.title}
                          file={pdfDespachoPreview.url}
                          download={pdfDespachoPreview.download}
                          onClose={() => {
                            setPdfDespachoPreview();
                          }}
                        />
                      )}
                      {formPreview && (
                        <Preview
                          title={'Vista previa'}
                          open={formPreview.open}
                          onClose={() => {
                            setFormPreview();
                          }}
                        >
                          <div className={classes.previewContainer}>
                            <FormDataView
                              baseObject={baseObject}
                              eventos={eventos}
                              isPhone={isPhone}
                              {...{
                                activeStep,
                                isPhone,
                                classes,
                                loadingSendPre,
                                handleBack,
                                handleOk
                              }}
                            />
                          </div>
                        </Preview>
                      )}
                    </Form>
                  </>
                )}
              </Formik>
            </div>
          </Container>
        </Paper>
      </div>
    </div>
  );
};

export default inject('datos')(observer(withSnackbar(EnvioDNAForm)));
